export const handleTime = (time) => {
  return new Date(`${time}:00.000Z`).getTime();
};

export function getCurrentQuarter() {
  const today = new Date();
  const month = today.getMonth() + 1; // getMonth() returns 0-11, so we add 1 to get 1-12

  return 'Q2';

  if (month >= 1 && month <= 3) {
    return 'Q1';
  } else if (month >= 4 && month <= 6) {
    return 'Q2';
  } else if (month >= 7 && month <= 9) {
    return 'Q3';
  } else {
    return 'Q4';
  }
}

export function getFullCurrentQuarter() {
  const today = new Date();
  const month = today.getMonth() + 1; // getMonth() returns 0-11, so we add 1 to get 1-12

  return 'Quarter 2';

  if (month >= 1 && month <= 3) {
    return 'Quarter 1';
  } else if (month >= 4 && month <= 6) {
    return 'Quarter 2';
  } else if (month >= 7 && month <= 9) {
    return 'Quarter 3';
  } else {
    return 'Quarter 4';
  }
}

export function getTotalPerformance(array, month, field, year) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const collection = array[i];
    const performance = collection.filter(
      (per) => per.month === month && per.year === year,
    );

    if (performance.length && performance[0][field]) {
      result += performance[0][field];
    }
  }

  if (result === 0) {
    return '-';
  }

  if (field === 'total_durations') {
    result = Math.round(result / 3600);
  }

  return result.toLocaleString();
}

export function getTotalIncome(
  array: any[],
  mrr: any[],
  index: string,
  month: number,
  year,
) {
  let total = 0;

  const monthMrr =
    (mrr as any)?.data?.filter(
      (item) => item.month === index && item.year == year,
    )[0] ?? 0;

  for (let i = 0; i < array.length; i++) {
    const collection = array[i];
    const performance = collection.filter((per) => per.month === month);

    if (
      (monthMrr as any)?.mrr_rev_share_20 &&
      (monthMrr as any)?.hours_all &&
      performance.length
    ) {
      total +=
        (Math.round((performance[0]?.total_durations ?? 0) / 3600) /
          Number((monthMrr as any)?.hours_all)) *
        (monthMrr as any)?.mrr_rev_share_20;
    }
  }

  return total;
}

export function getTotalAmountMGPerIP(array, mrr, isIPMGBalance = true) {
  let total = 0;

  const aprMrr = mrr?.data?.filter((item) => item.month === 'Apr')[0] ?? 0;
  const mayMrr = mrr?.data?.filter((item) => item.month === 'May')[0] ?? 0;
  const junMrr = mrr?.data?.filter((item) => item.month === 'Jun')[0] ?? 0;

  for (let i = 0; i < array.length; i++) {
    const collection = array[i];
    const aprPerformance = collection.filter((per) => per.month === 4);
    const mayPerformance = collection.filter((per) => per.month === 5);
    const junPerformance = collection.filter((per) => per.month === 6);
    const amount =
      (isIPMGBalance
        ? collection[0]?.collection_detail?.ip_mg_balance ?? 0
        : 0) -
      (Math.round((aprPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((aprMrr as any)?.hours_all)) *
        (aprMrr as any)?.mrr_rev_share_20 -
      (Math.round((mayPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((mayMrr as any)?.hours_all)) *
        (mayMrr as any)?.mrr_rev_share_20 -
      (Math.round((junPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((junMrr as any)?.hours_all)) *
        (junMrr as any)?.mrr_rev_share_20;

    if (amount < 0) {
      total += amount;
    }
  }
  return total * -1;
}

// export function getTotalAmountMGPerIPQ3(array, mrr, targetYear) {
//   let total = 0;

//   const aprMrr = mrr?.data?.filter((item) => item.month === 'Apr')[0] ?? 0;
//   const mayMrr = mrr?.data?.filter((item) => item.month === 'May')[0] ?? 0;
//   const junMrr = mrr?.data?.filter((item) => item.month === 'Jun')[0] ?? 0;
//   const julMrr = mrr?.data?.filter((item) => item.month === 'Jul')[0] ?? 0;
//   const augMrr = mrr?.data?.filter((item) => item.month === 'Aug')[0] ?? 0;
//   const sepMrr = mrr?.data?.filter((item) => item.month === 'Sep')[0] ?? 0;

//   for (let i = 0; i < array.length; i++) {
//     const collection = array[i];

//     const aprPerformance = collection.filter((per) => per.month === 4);
//     const mayPerformance = collection.filter((per) => per.month === 5);
//     const junPerformance = collection.filter((per) => per.month === 6);

//     // update this for future q
//     const lastMGBalance =
//       (collection[0]?.collection_detail?.ip_mg_balance ?? 0) -
//       (Math.round((aprPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((aprMrr as any)?.hours_all)) *
//         (aprMrr as any)?.mrr_rev_share_20 -
//       (Math.round((mayPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((mayMrr as any)?.hours_all)) *
//         (mayMrr as any)?.mrr_rev_share_20 -
//       (Math.round((junPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((junMrr as any)?.hours_all)) *
//         (junMrr as any)?.mrr_rev_share_20;

//     const julPerformance = collection.filter((per) => per.month === 7);
//     const augPerformance = collection.filter((per) => per.month === 8);
//     const sepPerformance = collection.filter((per) => per.month === 9);

//     const amount =
//       (lastMGBalance > 0 ? lastMGBalance : 0) -
//       (Math.round((julPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((julMrr as any)?.hours_all)) *
//         (julMrr as any)?.mrr_rev_share_20 -
//       (Math.round((augPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((augMrr as any)?.hours_all)) *
//         (augMrr as any)?.mrr_rev_share_20 -
//       (Math.round((sepPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((sepMrr as any)?.hours_all)) *
//         (sepMrr as any)?.mrr_rev_share_20;

//     if (amount < 0) {
//       total += amount;
//     }
//   }
//   return total * -1;
// }

// export function getTotalAmountMGPerIPQ4(array, mrr) {
//   let total = 0;
//   const octMrr = mrr?.data?.filter((item) => item.month === 'Oct')[0] ?? 0;
//   const novMrr = mrr?.data?.filter((item) => item.month === 'Nov')[0] ?? 0;
//   const decMrr = mrr?.data?.filter((item) => item.month === 'Dec')[0] ?? 0;

//   for (let i = 0; i < array.length; i++) {
//     const collection = array[i];

//     // update this for future q
//     const lastMGBalance =
//       collection[0]?.collection_detail?.ip_mg_balance_q3_24 ?? 0;

//     const octPerformance = collection.filter((per) => per.month === 10);
//     const novPerformance = collection.filter((per) => per.month === 11);
//     const decPerformance = collection.filter((per) => per.month === 12);

//     const amount =
//       (lastMGBalance > 0 ? lastMGBalance : 0) -
//       (Math.round((octPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((octMrr as any)?.hours_all)) *
//         (octMrr as any)?.mrr_rev_share_20 -
//       (Math.round((novPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((novMrr as any)?.hours_all)) *
//         (novMrr as any)?.mrr_rev_share_20 -
//       (Math.round((decPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((decMrr as any)?.hours_all)) *
//         (decMrr as any)?.mrr_rev_share_20;

//     if (amount < 0) {
//       total += amount;
//     }
//   }
//   return total * -1;
// }

// export function getTotalAmountMGPerIPQ1(array, mrr, licensor) {
//   let total = 0;
//   const janMrr = mrr?.data?.filter((item) => item.month === 'Jan')[0] ?? 0;
//   const febMrr = mrr?.data?.filter((item) => item.month === 'Feb')[0] ?? 0;
//   const marMrr = mrr?.data?.filter((item) => item.month === 'Mar')[0] ?? 0;

//   for (let i = 0; i < array.length; i++) {
//     const collection = array[i];

//     // update this for future q
// const lastMGBalance = collection[0]?.collection_detail
//         ?.is_mg_balance_used_for_current_calculation
//         ? collection[0]?.collection_detail[manualIPMGBalanceField]
//         ?? collection[0]?.collection_detail[IPMGBalanceField] ?? 0 : 0;

//     const janPerformance = collection.filter((per) => per.month === 1);
//     const febPerformance = collection.filter((per) => per.month === 2);
//     const marPerformance = collection.filter((per) => per.month === 3);

//     const amount =
//       (lastMGBalance > 0 ? lastMGBalance : 0) -
//       (Math.round((janPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((janMrr as any)?.hours_all)) *
//         (janMrr as any)?.mrr_rev_share_20 -
//       (Math.round((febPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((febMrr as any)?.hours_all)) *
//         (febMrr as any)?.mrr_rev_share_20 -
//       (Math.round((marPerformance[0]?.total_durations ?? 0) / 3600) /
//         Number((marMrr as any)?.hours_all)) *
//         (marMrr as any)?.mrr_rev_share_20 -
//       (licensor?.rev_share_5
//         ? (Math.round((janPerformance[0]?.total_durations ?? 0) / 3600) /
//             Number((janMrr as any)?.hours_5)) *
//             (janMrr as any)?.mrr_rev_share_5 +
//           (Math.round((febPerformance[0]?.total_durations ?? 0) / 3600) /
//             Number((febMrr as any)?.hours_5)) *
//             (febMrr as any)?.mrr_rev_share_5 +
//           (Math.round((marPerformance[0]?.total_durations ?? 0) / 3600) /
//             Number((marMrr as any)?.hours_5)) *
//             (marMrr as any)?.mrr_rev_share_5
//         : 0);

//     if (amount < 0) {
//       total += amount;
//     }
//   }
//   return total * -1;
// }

export function getTotalAmountMGPerIPQ1(
  array,
  mrr,
  licensor,
  targetYear,
  isMGBalance = true,
  manualIPMGBalanceField,
  IPMGBalanceField,
) {
  let total = 0;

  const octMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Jan',
    )[0] ?? 0;
  const novMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Feb',
    )[0] ?? 0;
  const desMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Mar',
    )[0] ?? 0;

  for (let i = 0; i < array.length; i++) {
    const collection = array[i];

    let lastMGBalance: number = 0;
    // update this for future q
    if (isMGBalance) {
      // lastMGBalance =
      //   collection[0]?.collection_detail?.ip_mg_balance_q4_25 ?? 0;
      lastMGBalance = collection[0]?.collection_detail
        ?.is_mg_balance_used_for_current_calculation
        ? collection[0]?.collection_detail[manualIPMGBalanceField] ??
          collection[0]?.collection_detail[IPMGBalanceField] ??
          0
        : 0;
    }

    const octPerformance = collection.filter((per) => per.month === 1);
    const novPerformance = collection.filter((per) => per.month === 2);
    const decPerformance = collection.filter((per) => per.month === 3);

    const amount =
      (lastMGBalance > 0 ? lastMGBalance : 0) -
      (Math.round((octPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((octMrr as any)?.hours_all)) *
        (octMrr as any)?.mrr_rev_share_20 -
      (Math.round((novPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((novMrr as any)?.hours_all)) *
        (novMrr as any)?.mrr_rev_share_20 -
      (Math.round((decPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((desMrr as any)?.hours_all)) *
        (desMrr as any)?.mrr_rev_share_20 -
      (licensor?.rev_share_5
        ? (Math.round((octPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((octMrr as any)?.hours_5)) *
            (octMrr as any)?.mrr_rev_share_5 +
          (Math.round((novPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((novMrr as any)?.hours_5)) *
            (novMrr as any)?.mrr_rev_share_5 +
          (Math.round((decPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((desMrr as any)?.hours_5)) *
            (desMrr as any)?.mrr_rev_share_5
        : 0);

    if (amount < 0) {
      total += amount;
    }
  }
  return total * -1;
}

export function getTotalAmountMGPerIPQ2(
  array,
  mrr,
  licensor,
  targetYear,
  isMGBalance = true,
  manualIPMGBalanceField,
  IPMGBalanceField,
) {
  let total = 0;

  const aprMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Apr',
    )[0] ?? 0;
  const mayMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'May',
    )[0] ?? 0;
  const junMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Jun',
    )[0] ?? 0;

  for (let i = 0; i < array.length; i++) {
    const collection = array[i];

    let lastMGBalance: number = 0;
    // update this for future q
    if (isMGBalance) {
      lastMGBalance = collection[0]?.collection_detail
        ?.is_mg_balance_used_for_current_calculation
        ? collection[0]?.collection_detail[manualIPMGBalanceField] ??
          collection[0]?.collection_detail[IPMGBalanceField] ??
          0
        : 0;
    }

    const aprPerformance = collection.filter((per) => per.month === 4);
    const mayPerformance = collection.filter((per) => per.month === 5);
    const junPerformance = collection.filter((per) => per.month === 6);

    const amount =
      (lastMGBalance > 0 ? lastMGBalance : 0) -
      (Math.round((aprPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((aprMrr as any)?.hours_all)) *
        (aprMrr as any)?.mrr_rev_share_20 -
      (Math.round((mayPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((mayMrr as any)?.hours_all)) *
        (mayMrr as any)?.mrr_rev_share_20 -
      (Math.round((junPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((junMrr as any)?.hours_all)) *
        (junMrr as any)?.mrr_rev_share_20 -
      (licensor?.rev_share_5
        ? (Math.round((aprPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((aprMrr as any)?.hours_5)) *
            (aprMrr as any)?.mrr_rev_share_5 +
          (Math.round((mayPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((mayMrr as any)?.hours_5)) *
            (mayMrr as any)?.mrr_rev_share_5 +
          (Math.round((junPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((junMrr as any)?.hours_5)) *
            (junMrr as any)?.mrr_rev_share_5
        : 0);

    if (amount < 0) {
      total += amount;
    }
  }
  return total * -1;
}

export function getTotalAmountMGPerIPQ3(
  array,
  mrr,
  licensor,
  targetYear,
  isMGBalance = true,
  manualIPMGBalanceField,
  IPMGBalanceField,
) {
  let total = 0;

  const julMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Jul',
    )[0] ?? 0;
  const augMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Aug',
    )[0] ?? 0;
  const sepMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Sep',
    )[0] ?? 0;

  for (let i = 0; i < array.length; i++) {
    const collection = array[i];

    let lastMGBalance: number = 0;
    // update this for future q
    if (isMGBalance) {
      lastMGBalance = collection[0]?.collection_detail
        ?.is_mg_balance_used_for_current_calculation
        ? collection[0]?.collection_detail[manualIPMGBalanceField] ??
          collection[0]?.collection_detail[IPMGBalanceField] ??
          0
        : 0;
    }

    const julPerformance = collection.filter((per) => per.month === 7);
    const augPerformance = collection.filter((per) => per.month === 8);
    const sepPerformance = collection.filter((per) => per.month === 9);

    const amount =
      (lastMGBalance > 0 ? lastMGBalance : 0) -
      (Math.round((julPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((julMrr as any)?.hours_all)) *
        (julMrr as any)?.mrr_rev_share_20 -
      (Math.round((augPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((augMrr as any)?.hours_all)) *
        (augMrr as any)?.mrr_rev_share_20 -
      (Math.round((sepPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((sepMrr as any)?.hours_all)) *
        (sepMrr as any)?.mrr_rev_share_20 -
      (licensor?.rev_share_5
        ? (Math.round((julPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((julMrr as any)?.hours_5)) *
            (julMrr as any)?.mrr_rev_share_5 +
          (Math.round((augPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((augMrr as any)?.hours_5)) *
            (augMrr as any)?.mrr_rev_share_5 +
          (Math.round((sepPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((sepMrr as any)?.hours_5)) *
            (sepMrr as any)?.mrr_rev_share_5
        : 0);

    if (amount < 0) {
      total += amount;
    }
  }
  return total * -1;
}

export function getTotalAmountMGPerIPQ4(
  array,
  mrr,
  licensor,
  targetYear,
  isMGBalance = true,
  manualIPMGBalanceField,
  IPMGBalanceField,
) {
  let total = 0;

  const octMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Oct',
    )[0] ?? 0;
  const novMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Nov',
    )[0] ?? 0;
  const desMrr =
    mrr?.data?.filter(
      (item) => item.year === targetYear && item.month === 'Dec',
    )[0] ?? 0;

  for (let i = 0; i < array.length; i++) {
    const collection = array[i];

    let lastMGBalance: number = 0;
    // update this for future q
    if (isMGBalance) {
      lastMGBalance = collection[0]?.collection_detail
        ?.is_mg_balance_used_for_current_calculation
        ? collection[0]?.collection_detail[manualIPMGBalanceField] ??
          collection[0]?.collection_detail[IPMGBalanceField] ??
          0
        : 0;
    }

    const octPerformance = collection.filter((per) => per.month === 10);
    const novPerformance = collection.filter((per) => per.month === 11);
    const decPerformance = collection.filter((per) => per.month === 12);

    const amount =
      (lastMGBalance > 0 ? lastMGBalance : 0) -
      (Math.round((octPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((octMrr as any)?.hours_all)) *
        (octMrr as any)?.mrr_rev_share_20 -
      (Math.round((novPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((novMrr as any)?.hours_all)) *
        (novMrr as any)?.mrr_rev_share_20 -
      (Math.round((decPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((desMrr as any)?.hours_all)) *
        (desMrr as any)?.mrr_rev_share_20 -
      (licensor?.rev_share_5
        ? (Math.round((octPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((octMrr as any)?.hours_5)) *
            (octMrr as any)?.mrr_rev_share_5 +
          (Math.round((novPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((novMrr as any)?.hours_5)) *
            (novMrr as any)?.mrr_rev_share_5 +
          (Math.round((decPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((desMrr as any)?.hours_5)) *
            (desMrr as any)?.mrr_rev_share_5
        : 0);

    if (amount < 0) {
      total += amount;
    }
  }
  return total * -1;
}

export function getTotalIncome5(
  array: any[],
  mrr: any[],
  index: string,
  month: number,
  year: string | number,
) {
  let total = 0;

  const monthMrr =
    (mrr as any)?.data?.filter(
      (item) => item.month === index && item.year == year,
    )[0] ?? 0;

  for (let i = 0; i < array.length; i++) {
    const collection = array[i];
    const performance = collection.filter((per) => per.month === month);

    if (
      (monthMrr as any)?.hours_5 &&
      (monthMrr as any)?.mrr_rev_share_5 &&
      performance.length
    ) {
      total +=
        (Math.round((performance[0]?.total_durations ?? 0) / 3600) /
          Number((monthMrr as any)?.hours_5)) *
        (monthMrr as any)?.mrr_rev_share_5;
    }
  }

  return total;
}

export function getTotalPerformanceReturnInteger(array, index, field) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const collection = array[i].filter(
      (item) => item.month >= 4 && item.month <= 6,
    );

    if (
      collection[index] &&
      collection[index][field] &&
      4 <= collection[index].month &&
      collection[index].month <= 6
    ) {
      result += collection[index][field];
    }
  }

  if (field === 'total_durations') {
    result = Math.round(result / 3600);
  }

  return result;
}

export function getTotalPerformanceReturnIntegerQ3(array, index, field, year) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const collection = array[i].filter(
      (item) => item.month >= 7 && item.month <= 9 && item.year === year,
    );

    if (
      collection[index] &&
      collection[index][field] &&
      7 <= collection[index].month &&
      collection[index].month <= 9
    ) {
      result += collection[index][field];
    }
  }

  if (field === 'total_durations') {
    result = Math.round(result / 3600);
  }

  return result;
}

export function getTotalPerformanceReturnIntegerQ4(array, index, field, year) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const collection = array[i].filter(
      (item) => item.month >= 10 && item.month <= 12 && item.year === year,
    );

    if (
      collection[index] &&
      collection[index][field] &&
      10 <= collection[index].month &&
      collection[index].month <= 12
    ) {
      result += collection[index][field];
    }
  }

  if (field === 'total_durations') {
    result = Math.round(result / 3600);
  }

  return result;
}

export function getTotalPerformanceReturnIntegerQ1(array, index, field, year) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const collection = array[i].filter(
      (item) => item.month >= 1 && item.month <= 3 && item.year === year,
    );

    if (
      collection[index] &&
      collection[index][field] &&
      1 <= collection[index].month &&
      collection[index].month <= 3
    ) {
      result += collection[index][field];
    }
  }

  if (field === 'total_durations') {
    result = Math.round(result / 3600);
  }

  return result;
}

export function getTotalPerformanceReturnIntegerQ2(array, index, field, year) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const collection = array[i].filter(
      (item) => item.month >= 4 && item.month <= 6 && item.year === year,
    );

    if (
      collection[index] &&
      collection[index][field] &&
      4 <= collection[index].month &&
      collection[index].month <= 6
    ) {
      result += collection[index][field];
    }
  }

  if (field === 'total_durations') {
    result = Math.round(result / 3600);
  }

  return result;
}

export function getCountTotal(array = [], field) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const item: any = array[i];
    if (['Apr', 'May', 'Jun'].includes(item.month)) {
      if (item[field]) {
        result += Number(item[field]);
      }
    }
  }

  return result;
}

export function getCountTotalQ3(array = [], field, year) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const item: any = array[i];
    if (['Jul', 'Aug', 'Sep'].includes(item.month) && item.year === year) {
      if (item[field]) {
        result += Number(item[field]);
      }
    }
  }

  return result;
}

export function getCountTotalQ4(array = [], field, year) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const item: any = array[i];
    if (['Oct', 'Nov', 'Dec'].includes(item.month) && item.year === year) {
      if (item[field]) {
        result += Number(item[field]);
      }
    }
  }

  return result;
}

export function getCountTotalQ1(array = [], field, year) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const item: any = array[i];
    if (['Jan', 'Feb', 'Mar'].includes(item.month) && item.year === year) {
      if (item[field]) {
        result += Number(item[field]);
      }
    }
  }

  return result;
}

export function getCountTotalQ2(array = [], field, year) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const item: any = array[i];
    if (['Apr', 'May', 'Jun'].includes(item.month) && item.year === year) {
      if (item[field]) {
        result += Number(item[field]);
      }
    }
  }

  return result;
}

export function getTotalMGPerIP(array: any[] = [], field) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const item: any = array[i][0].collection_detail;
    if (item[field]) {
      result += Number(item[field]);
    }
  }

  return result;
}

export function getTotalMGPerIPPerformance(
  array: any[] = [],
  firstMonthNumber,
  secondMonthNumber,
  thirdMonthNumber,
  targetYear,
  firstMonthMrr,
  secondMonthMrr,
  thirdMonthMrr,
  licensor,
) {
  let result = 0;
  for (let i = 0; i < array.length; i++) {
    const collection = array[i];

    const firstMonthPerformance = collection.filter(
      (per) =>
        per.month === firstMonthNumber && per.year === Number(targetYear),
    );
    const secondMonthPerformance = collection.filter(
      (per) =>
        per.month === secondMonthNumber && per.year === Number(targetYear),
    );
    const thirdMonthPerformance = collection.filter(
      (per) =>
        per.month === thirdMonthNumber && per.year === Number(targetYear),
    );

    const firstMonthPerformanceIncome =
      (Math.round((firstMonthPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((firstMonthMrr as any)?.hours_all)) *
      (firstMonthMrr as any)?.mrr_rev_share_20;

    const secondMonthPerformanceIncome =
      (Math.round((secondMonthPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((secondMonthMrr as any)?.hours_all)) *
      (secondMonthMrr as any)?.mrr_rev_share_20;

    const thirdMonthPerformanceIncome =
      (Math.round((thirdMonthPerformance[0]?.total_durations ?? 0) / 3600) /
        Number((thirdMonthMrr as any)?.hours_all)) *
      (thirdMonthMrr as any)?.mrr_rev_share_20;

    const performance =
      firstMonthPerformanceIncome +
      secondMonthPerformanceIncome +
      thirdMonthPerformanceIncome +
      (licensor?.rev_share_5
        ? (Math.round((firstMonthPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((firstMonthMrr as any)?.hours_5)) *
            (firstMonthMrr as any)?.mrr_rev_share_5 +
          (Math.round(
            (secondMonthPerformance[0]?.total_durations ?? 0) / 3600,
          ) /
            Number((secondMonthMrr as any)?.hours_5)) *
            (secondMonthMrr as any)?.mrr_rev_share_5 +
          (Math.round((thirdMonthPerformance[0]?.total_durations ?? 0) / 3600) /
            Number((thirdMonthMrr as any)?.hours_5)) *
            (thirdMonthMrr as any)?.mrr_rev_share_5
        : 0);

    result += performance;
  }

  return result;
}

export const tagsAutocompleteClassNames = {
  root: 'react-tags form-control form-control-lg form-control-solid d-flex align-items-center',
  rootIsActive: 'is-active',
  rootIsDisabled: 'is-disabled',
  rootIsInvalid: 'is-invalid',
  label: 'react-tags__label',
  tagList: 'react-tags__list m-0',
  tagListItem: 'react-tags__list-item',
  tag: 'react-tags__tag',
  tagName: 'react-tags__tag-name',
  comboBox: 'react-tags__combobox',
  input: 'react-tags__combobox-input',
  listBox: 'react-tags__listbox ',
  option: 'react-tags__listbox-option',
  optionIsActive: 'is-active',
  highlight: 'react-tags__listbox-option-highlight',
};

export const TAGS = [
  { value: '1', label: 'Aksi' },
  { value: '2', label: 'Kembara' },
  { value: '3', label: 'Lagu Anak' },
];

export const HOME_BUTTON_DISPLAY_PARAMS = [
  { value: 'row-vertical-video', label: 'Row Vertical Video' },
  { value: 'row-vertical-channel', label: 'Row Vertical Channel' },
  { value: 'row-trending', label: 'Row Trending' },
  { value: 'row-horizontal-big', label: 'Row Horizontal Big' },
];

export const COUNTRIES = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AX', label: 'Aland Islands' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia, Plurinational State of' },
  { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo, the Democratic Republic of the' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: "Côte d'Ivoire" },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands (Malvinas' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See (Vatican City State' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran, Islamic Republic of' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: "Korea, Democratic People's Republic of" },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: "Lao People's Democratic Republic" },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MK', label: 'Macedonia, the former Yugoslav Republic of' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia, Federated States of' },
  { value: 'MD', label: 'Moldova, Republic of' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestinian Territory, Occupied' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin (French part' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch part' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'KR', label: 'South Korea' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SZ', label: 'Swaziland' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syrian Arab Republic' },
  { value: 'TW', label: 'Taiwan, Province of China' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania, United Republic of' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela, Bolivarian Republic of' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'VI', label: 'Virgin Islands' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
];
